import React, { Fragment } from 'react';
import usePageSeo from '../../hooks/usePageSeo';
import Header from '../../components/header/Header';
import PageTitle from '../../components/pagetitle/PageTitle';
import Scrollbar from '../../components/scrollbar/scrollbar';
import Footer from '../../components/footer/Footer';
import CtaSection from '../../components/CtaSection/CtaSection';
import ContactSection from '../../components/ContactSection';

const ContactPage = (props) => {

    usePageSeo({
        title: 'Contact Us — California Technology Consulting',
        description: 'Contact BUILDLAB for low-voltage design, managed IT, and affordable housing technology across California. (858) 952-6234 · info@buildlabconsulting.com.',
        keywords: 'contact BUILDLAB, BUILDLAB phone, BUILDLAB email, California technology consultant, Escondido technology consultant',
    });

    return (
        <Fragment>
            <Header />
            <main id="main-content" className="page_content about-page">
                <PageTitle pageTitle={'Contact Us'} pagesub={'Us '} pageTop={'Contact'} />
                <ContactSection />
                <CtaSection />
            </main>
            <Footer />
            <Scrollbar />
        </Fragment>
    )
};

export default ContactPage;